import { StyleSheet } from "react-native";
const styles = StyleSheet.create({
    formGroup: {
        marginBottom: 0,
    },
    label: {
        fontSize: 11,
        lineHeight: 13,
        marginLeft: 0,
    },
    input: {
        width: "100%",
        fontSize: 16,
        lineHeight: 20,
        ...{ outlineStyle: "none" },
    },
    inputMultilineWithLabel: {
        paddingTop: 0,
    },
    inputMultiline: {
        paddingTop: 5,
        height: 130,
    },
    inputGroup: {
        height: "100%",
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
    },
    inputContainer: {
        height: 56,
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: 12,
        borderRadius: 28,
        borderWidth: 1,
        paddingHorizontal: 22,
        backgroundColor: "white",
    },
    inputContainerMultiline: {
        height: 155,
        paddingVertical: 10.5,
        alignItems: "flex-start",
    },
    inputContainerOutline: {
        ...{ outlineStyle: "solid", outlineWidth: 2, outlineOffset: -1 },
    },
    passwordIcon: {
        padding: 10,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
    },
    errorText: { minHeight: 30, paddingHorizontal: 24, paddingTop: 8 },
    collapsibleErrorText: { paddingHorizontal: 24, paddingTop: 8 },
    descriptionTextContainer: {
        paddingHorizontal: 22,
        paddingVertical: 8,
        marginHorizontal: 0,
        marginTop: 12,
        borderRadius: 28,
    },
});
export { styles };
//# sourceMappingURL=TextInput.styles.web.js.map